import { Container, Row, Col, Card } from 'react-bootstrap';

const Terms = () => {
  const sections = [
    {
      title: '1. Acceptance of Terms',
      content: 'By accessing or using Paperdate, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services. We reserve the right to modify these terms at any time, and your continued use constitutes acceptance of any changes.'
    },
    {
      title: '2. Eligibility',
      content: 'You must be at least 18 years old to use Paperdate. By using our services, you represent and warrant that you are at least 18 years of age and have the legal capacity to enter into these terms. We reserve the right to verify your age at any time.'
    },
    {
      title: '3. Account Registration',
      content: 'You must provide accurate, current, and complete information during registration. You are responsible for maintaining the confidentiality of your account credentials and for all activities under your account. Notify us immediately of any unauthorized use.'
    },
    {
      title: '4. User Conduct',
      content: 'You agree not to: use the service for illegal purposes; harass, abuse, or harm others; impersonate any person or entity; post false or misleading information; upload malicious code; attempt to gain unauthorized access; or violate any applicable laws or regulations.'
    },
    {
      title: '5. Content Guidelines',
      content: 'You retain ownership of content you post but grant Paperdate a license to use, display, and distribute it. You are solely responsible for your content. We may remove content that violates our guidelines without notice. Prohibited content includes nudity, hate speech, and copyrighted material.'
    },
    {
      title: '6. Credits and Payments',
      content: 'Some features require credits purchased through our platform. All purchases are final and non-refundable except as required by law. Prices are subject to change. You are responsible for any applicable taxes. Unused credits expire after 12 months of account inactivity.'
    },
    {
      title: '7. Privacy',
      content: 'Your privacy is important to us. Our Privacy Policy explains how we collect, use, and protect your personal information. By using Paperdate, you consent to our data practices as described in the Privacy Policy.'
    },
    {
      title: '8. Termination',
      content: 'We may suspend or terminate your account at any time for violations of these terms or for any other reason at our discretion. You may delete your account at any time through your account settings. Upon termination, your right to use the service ceases immediately.'
    },
    {
      title: '9. Disclaimers',
      content: 'Paperdate is provided "as is" without warranties of any kind. We do not guarantee matches, relationships, or outcomes. We are not responsible for user conduct or content. Use the service at your own risk. We do not conduct background checks on users.'
    },
    {
      title: '10. Limitation of Liability',
      content: 'To the maximum extent permitted by law, Paperdate shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the service. Our total liability shall not exceed the amount you paid us in the past 12 months.'
    },
    {
      title: '11. Contact Information',
      content: 'For questions about these Terms of Service, please contact us at legal@paperdate.io or write to us at Paperdate Legal, 123 Dating Street, San Francisco, CA 94102.'
    }
  ];

  return (
    <Container className="py-5">
      <Row className="justify-content-center mb-5">
        <Col lg={8} className="text-center">
          <h1 className="display-4 fw-bold mb-4">Terms of Service</h1>
          <p className="text-muted">Last updated: January 1, 2024</p>
        </Col>
      </Row>

      <Row className="justify-content-center">
        <Col lg={10}>
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-4 p-lg-5">
              {sections.map((section, index) => (
                <div key={index} className={index < sections.length - 1 ? 'mb-4' : ''}>
                  <h5 className="fw-bold mb-3">{section.title}</h5>
                  <p className="text-muted mb-0">{section.content}</p>
                </div>
              ))}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Terms;

